module.exports = {
    Lang: {
        de: 'Alemán',
        en: 'Inglés',
        es: 'Español',
        fr: 'Francés',
        pt: 'Portugués',
        it: 'Italiano',
        ru: 'Ruso'
    },
    Action: {
        add: 'Añadir',
        edit: 'Editar',
        remove: 'Eliminar pedido',
        close: 'Cerrar',
        select: 'Seleccionar',
        save: 'Guardar',
        saving: 'Está guardado',
        send: 'Enviar',
        confirmSelection: 'Confirmar selección',
        change: 'Modificar',
        changeSelection: 'Cambiar selección',
        next: 'Siguiente',
        prev: 'Atrás',
        finish: 'Finalizar',
        'search': 'Buscar'
    },
    Common: {
        start: 'Comienzo',
        date: 'Fecha',
        creationdate: 'Fecha de creación',
        lastmodified: 'Última modificación',
        status: 'Estado',
        color: 'Color',
        settings: 'Ajustes',
        masterdata: 'Datos maestros',
        masterdataSaved: 'Se han guardado los datos maestros.',
        amount: 'Precio',
        description: 'Descripción',
        item: 'Artículo',
        itemNum: 'N.º del artículo',
        itemName: 'Nombre del artículo',
        itemPrice: 'Artículo Precio',
        quantity: 'Cantidad',
        singlePrice: 'Precio unitario',
        discount: 'Descuento',
        rebate: 'reembolso',
        vat: 'IVA',
        total: 'Total',
        orderPrice: 'precio del pedido',
        annotation: 'anotación',
        accountDetails: 'Información del cliente',
        customerNum: 'N.º de cliente',
        salutation: 'Tratamiento',
        firstname: 'Nombre',
        lastname: 'Apellidos',
        company: 'Empresa',
        email: 'Correo electrónico',
        contact: 'Contacto',
        address: 'Dirección',
        postalcode: 'Código postal',
        city: 'Ciudad',
        country: 'País',
        taxDetails: 'Datos fiscales',
        vatId: 'C.I.F.',
        noEntries: 'no entrar',
        languageSettings: 'Ajustes del idioma',
        showXtoYentries: 'Mostrar de {x} a {y} resultados',
        showXtoYofZentries: 'Mostrando {x} a {y} de {z} resultados',
        errorSavingMasterdata: 'No se pudieron guardar los datos maestros.',
        errorIncomplete: 'Formulario incompleto',
        errorFieldMissing: '{field} debe completarse',
        errorUploadInvalidResp: 'Respuesta inválida del servidor. Por favor intente nuevamente o contacte a nuestro soporte.',
        noSelection: 'No hay selección'
    },
    Units: {
        C62: 'pcs.',
        GRM: 'g'
    },
    Dashboard: {
        title: 'Cuadro de mando'
    },
    Addresses: {
        title: 'Direcciones',
        add: 'Nueva dirección',
        addressMain: 'Dirección principal',
        addressBilling: 'Dirección de Envio',
        addressShipping: 'Dirección de entrega',
        confirmRemove: '¿Estás seguro de que deseas eliminar el contacto?',
        errorLoad: 'Las direcciones no se pudieron cargar.',
        errorRemove: 'La dirección no se pudo eliminar.'
    },
    EditAddress: {
        title: 'nueva dirección',
        errorTypeTitle: 'Por favor, especifique un tipo de dirección.',
        errorTypeText: 'La dirección debe ser una dirección de entrega y / o factura.',
        errorCreate: 'No se pudo crear la dirección.',
        errorUpdate: 'La dirección no se pudo actualizar.',
        shipping: 'Entregas',
        useForShippingNo: 'No utilizar como dirección de entrega.',
        useForShippingYes: 'Usar como dirección de envío',
        useForShippingDefault: 'El uso de la dirección de entrega estándar',
        billing: 'Facturas',
        useForBillingNo: 'No utilizar como dirección de facturación',
        useForBillingYes: 'Usar como dirección de facturación',
        useForBillingDefault: 'Como dirección de factura estándar Uso'
    },
    Projects: {
        title: 'Informes',
        loading: 'Cargando informes',
        currentProjects: 'Informes actuales',
        showAll: 'Mostrar todos los informes',
        noProjects: 'No hay informes',
        add: 'Agregar informe',
        projectNumber: 'Informe No.',
        projectName: 'Identificación del paciente',
        projectType: 'Tipo de informe',
        statusAll: 'Todos los informes',
        statusOpen: 'Informes abiertos',
        statusOrdered: 'Informes ordenados',
        errorNoName: 'Por favor, introduzca el nombre del informe.',
        errorCreate: 'El informe no pudo ser creado.',
        errorCouldNotLoad: 'Los informes no pudieron ser cargados.'
    },
    ProjectDetails: {
        title: 'Detalles del pedido',
        loading: 'El informe está cargado',
        alertOrdered: 'Informe ordenado',
        openOrder: 'Orden abierta',
        alertReference: 'Este proyecto está vinculado a otro proyecto:',
        openProject: 'Abrir informe',
        toothSelection: 'selección de dientes',
        noConstruction: 'Keine Konstruktion festgelegt!',
        editConstruction: 'Kontruktion bearbeiten',
        materialSelection: 'Materialauswahl',
        estimatedDelivery: 'Vorauss. Lieferdatum',
        missingMaterial: 'Materialauswahl fehlt',
        missingAttachments: 'Archivos adjuntos que faltan:',
        addStl: 'STL hinzufügen',
        openCart: 'Al carro de la compra',
        emptyCart: 'Cesta vacía',
        shippingType: 'Método de envío',
        construction: 'Konstruktion',
        stlUpload: 'STL Upload',
        attachments: 'Archivos adjuntos',
        addons: 'Productos adicionales',
        cart: 'Cesta de la compra',
        addItem: 'Añadir artículo',
        orderProject: 'Confirme el pedido',
        statusNotOrdered: 'Aún no pedido',
        statusOrdered: 'Ordenes',
        errorNoProjectnum: 'No se ha transferido un número de informe válido',
        costs: 'Coste del proyecto',
        removed: 'Proyecto eliminado',
        removing: 'El proyecto es eliminado',
        saved: 'Proyecto guardado',
        saving: 'El proyecto se salva',
        orderSuccessful: 'El pedido ha tenido éxito'
    },
    Orders: {
        title: 'Pedidos',
        loading: 'Las órdenes están cargadas',
        currentOrders: 'Los pedidos actuales',
        openOrder: 'Orden abierta',
        showAll: 'Mostrar todas las órdenes',
        noOrders: 'No hay órdenes',
        orderNum: 'Pedido n.º',
        projectRef: 'Referencia del proyecto',
        statusAll: 'Todas las órdenes',
        errorCouldNotLoad: 'Las órdenes no pudieron ser cargadas',
        statusNotOrdered: 'Aún no pedido',
        statusReceived: 'Recibido',
        statusCancelled: 'Cancelado',
        statusReceivedDescr: 'El pedido se comprueba',
        statusInProgress: 'En proceso',
        statusInProgressDescr: 'Su pedido está siendo procesado',
        statusInProduction: 'En la producción',
        statusInProductionDescr: 'La producción ha comenzado',
        statusDelivered: 'Enviado a',
        statusDeliveredDescr: 'Su pedido ha sido enviado'
    },
    Reports: {
        statusAll: 'Todos los informes',
        statusReceived: 'Datos recibidos',
        statusReceivedDescr: 'Su pedido se está comprobando.',
        statusInProgress: 'En curso',
        statusInProgressDescr: 'Su pedido está siendo procesado.',
        statusInProduction: 'Plantilla de informe lista',
        statusInProductionDescr: 'Se crea su plantilla de informe',
        statusOnHold: 'Contenido',
        statusCancelled: 'Cancelado',
        statusCancelledDescr: 'Su pedido fue cancelado',
        statusClosed: 'Informe generado',
        statusCompleted: 'Informe generado',
        statusCompletedDescr: 'Ha generado su informe.',
        statusInvoicedCancelled: 'Teilberechnet / Storniert',
        statusPartlyDelivered: 'Teilgeliefert',
        statusPartlyDeliveredCancelled: 'Teilgeliefert / Storniert',
        statusPartlyDeliveredClosed: 'Teilgeliefert / Geschlossen',
        statusDelivered: 'Informe generado',
        statusDeliveredDescr: 'Su informe está completo',
        statusReadyForPickup: 'Listo para la colección',
    },
    OrderDetails: {
        title: 'Detalles del pedido',
        deliveryNote: 'nota de entrega',
        loading: 'La orden está cargada',
        trackingNum: 'No de rastreo.',
        manufacturingStatus: 'Estado de la producción',
        trackingAndBilling: 'Seguimiento y facturación',
        creatingOrder: 'Se crea el orden',
        orderProject: 'Confirme el pedido',
        placeOrder: 'Haga su pedido',
        acceptTerms: 'He leído y aceptado las <a href="{termsUrl}" target="_blank">Condiciones Generales</a>.',
        errorNoOrderNum: 'No se ha transferido ningún número de orden válido',
        errorCouldNotLoad: 'La orden no pudo ser cargada',
        priceNobleMetal1: 'Der Endgültige Produktpreis ist bei Edelmetallen vom endgültigen Gewicht abhängig.',
        priceNobleMetal2: 'Bitte prüfen Sie hierzu Ihren Lieferschein, sobald der Auftrag abgeschlossen ist.',
        files: 'Archivos'
    },
    Messages: {
        title: 'Noticias',
        noMessages: 'Keine Nachrichten',
        errorCouldNotLoad: 'Nachrichten konnte nicht geladen werden',
        writeSomething: 'Schreiben Sie was...',
        errorSendingMessage: 'Nachricht konnte nicht gesendet werden.'
    },
    Configurator: {
        selectIndication: 'Indikation wählen',
        changeMaterial: 'Material ändern',
        selectTooth: 'Bitte wählen Sie einen Zahn',
        showToothNumbers: 'Zahnnummern anzeigen',
        toothSelection: 'Zahnauswahl',
        setProductProps: 'Produkteigenschaften festlegen',
        selectProduct: 'Produkt wählen',
        fileXofY: 'Datei {x} von {y}',
        calcPrice: 'Preise werden berechnet',
        uploadStl: 'STL hochladen',
        stlCount: 'Einheitenanzahl der obigen STL',
        stlCountTooltip: 'Bitte Einheitenanzahl der STL-Datei angeben, z.B. 3 Einheiten bei dreigliedriger Brücke',
        oneUnit: 'Eine Einheit',
        nUnits: '{n} Einheiten',
        removeJawSelection: 'Wollen sie die bestehende Auswahl in diesem Kiefer entfernen?',
        invalidTeethInRange: 'The {0} teeth is invalid for range {1}-{2}.',
        invalidRange: 'The {0}-{1} tooth range is invalid. The start/end teeth have to be on the same jaw.',
        invalidTeethNumber: 'The {0} is invalid teeth number.',
        transferSettings: 'Do you want to transfer those settings to multiple teeth?',
        clickOnConnectTooth: 'Click on the tooth you want to connect to'
    },
    Invoices: {
        title: 'Rechnungen',
        loading: 'Rechnungen werden geladen',
        invoiceNum: 'Rechnung Nr.',
        monthlyStatement: 'Monatsaufstellung',
        statusReceived: 'Eingegangen',
        statusOpen: 'Offen',
        statusHold: 'Gehalten',
        statusCancelled: 'Storniert',
        statusClosed: 'Geschlossen',
        statusPartlyPaid: 'Teilbezahlt',
        statusPartlyPaidCancelled: 'Teilbezahlt / Storniert',
        statusPartlyPaidClosed: 'Teilbezahlt / Geschlossen',
        statusPaid: 'Bezahlt'
    },
    File: {
        name: 'Nombre del archivo',
        hash: 'Hachís de archivo',
        size: 'Tamaño del archivo',
        messageUpload: 'Haga clic o arrastre el archivo al recuadro para cargarlo.',
        allFilesSameMaterial: 'Alle Dateien haben das gleiche Material',
        sendingData: 'Los datos se transmiten',
        processingData: 'Los datos se procesan',
        errorUpload: 'Se ha producido un error. Desafortunadamente el archivo no pudo ser subido.',
        errorCouldNotList: 'Los archivos no pudieron ser cargados.',
        errorCouldNotLoad: 'El archivo no pudo ser cargado.',
        errorCouldNotDelete: 'El archivo no pudo ser removido.'
    },
    Login: {
        username: 'Correo electrónico o número de cliente',
        password: 'Contraseña',
        passwordOld: 'Contraseña antigua',
        passwordNew: 'Nueva contraseña',
        passwordConfirm: 'Confirmar la nueva contraseña',
        passwordSaved: 'Contraseña guardada',
        login: 'Iniciar sesión',
        logout: 'Cierre de sesión',
        enterPwd: 'Por favor, introduzca una contraseña.',
        invalidUserOrPwd: 'Nombre de usuario o contraseña no válidos',
        errorCouldNotUpdate: 'La contraseña no pudo ser guardada.',
        errorPasswordNoMatch: 'Las contraseñas no coinciden.',
        errorOldPassword: 'La vieja contraseña está equivocada.',
        errorNoSession: 'No se encontró ninguna sesión de usuario. Por favor, inicie sesión.'
    },
    Infothek: {
        title: 'Infoteca'
    }
};
